module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="job-card-title-container">\n    <div class="job-card-title">\n        <a\n            href="' +
__e( link ) +
'"\n            class="js-job-detail js-job-data"\n            data-id="position-detail-' +
__e( id ) +
'"\n            data-url="' +
__e( link ) +
'"\n            data-hide-footer="true"\n        >' +
__e( title ) +
'</a>\n    </div>\n    <div class="job-card-subtitle">' +
__e( company_name ) +
' | ' +
__e( location_name ) +
'</div>\n</div>\n<div class="job-card-meta-container">\n    <ul>\n        ';
 if (wage > 0) { ;
__p += '\n        <li>\n            <span class="job-card-label">Pay:</span>\n            <span class="job-card-content">$' +
__e( wage ) +
'/hour starting wage</span>\n        </li>\n        ';
 } ;
__p += '\n        ';
 if (schedule_start) { ;
__p += '\n        <li>\n            <span class="job-card-label">Shift:</span>\n            <span class="job-card-content">\n                ' +
__e( schedule_start );
 if (schedule_duration) { ;
__p += ', ' +
__e( schedule_duration );
 } ;

 if (schedule_description) { ;
__p += ', ' +
__e( schedule_description );
 } ;
__p += '\n            </span>\n        </li>\n        ';
 } ;
__p += '\n        ';
 if (schedule_type_text) { ;
__p += '\n        <li>\n            <span class="job-card-label">Type:</span>\n            <span class="job-card-content">' +
__e( schedule_type_text ) +
'</span>\n        </li>\n        ';
 } ;
__p += '\n    </ul>\n</div>\n<div class="job-card-button">\n    <a\n        href="' +
__e( link ) +
'"\n        class="btn js-job-detail js-job-data"\n        data-id="position-detail-' +
__e( id ) +
'"\n        data-url="' +
__e( link ) +
'"\n        data-hide-footer="true"\n    >View Job Details</a>\n</div>\n';

}
return __p
}